import { Component, OnInit } from '@angular/core';
//import { TranslateService } from '@ngx-translate/core';
import { ModalController } from '@ionic/angular';
import { LoaderService } from 'src/app/shared/services/loader.service';
import { IProfilePhoneEditForm } from '../../forms/profile-phone-edit-form/profile-phone-edit-form.component';
import { ProfileService } from '../../services/profile.service';
import { finalize } from 'rxjs/operators';

@Component({
    selector: 'app-profile-phone-edit-modal',
    templateUrl: './profile-phone-edit-modal.component.html',
    styleUrls: ['./profile-phone-edit-modal.component.scss'],
    standalone: false
})
export class ProfilePhoneEditModalComponent implements OnInit {
  title: string = "Nav.UpdatePhoneNumber";

  constructor(
    private loader: LoaderService,
    private profile: ProfileService,
    private modalCtrl: ModalController) { }

  ngOnInit() {}

  async onFormSubmitted(form: IProfilePhoneEditForm) {
    const loader = await this.loader.create();
    await loader.present();
    this.profile.setPhoneNumber(form.phone)
      .pipe(finalize(async () => {
        await loader.dismiss();
      }))
      .subscribe(() => {
        this.modalCtrl.dismiss(true);
      });
  }

  cancel() {
    this.modalCtrl.dismiss(null);
  }
}
